export const getFoodReferrerLabel = (referrer: string) => {
  if (referrer.startsWith('/purchased-goods/reports')) {
    return 'Back to report';
  }
  if (referrer.startsWith('/purchased-goods/insights')) {
    return 'Back to insights';
  }
  if (referrer.startsWith('/purchased-goods')) {
    return 'Back to food and drink';
  }
  if (referrer.startsWith('/company-reports')) {
    return 'Back to company report';
  }

  return 'Back';
};

export const getPackagingReferrerLabel = (referrer: string) => {
  if (referrer.startsWith('/purchased-goods/reports/')) {
    return 'Back to report';
  }
  if (referrer.startsWith('/purchased-goods/insights')) {
    return 'Back to insights';
  }
  if (referrer.startsWith('/purchased-goods')) {
    return 'Back to packaging';
  }
  if (referrer.startsWith('/company-reports')) {
    return 'Back to company report';
  }

  return 'Back';
};
